import { IStation } from 'shared/api/api';

export const GET_StationData = 'GET_StationData';

export interface EsfStationDataState {
    data: IStation[],
    lastSyncDate?: Date;
}
